module.exports = __webpack_public_path__ + "img/mixpayment.602a4786.jpeg";